import React, { useEffect, useState } from "react";
import { SimpleGrid } from "@chakra-ui/react";
import TotalDepartment from "./TotalDepartment";
import PendingReports from "./PendingReports";
import QueriedReports from "./QueriedReports";
import ApprovedReports from "./ApprovedReports";
import { getUsers } from "../../util/http";
import TotalDirectorate from "./TotalDirectorate";

export default function DashboardReport({ report }) {
  const id = localStorage.getItem("memberID");
  const token = localStorage.getItem("token");
  const [user, setUser] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getUsers(token, id);
        setUser(response?.user[0]);
      } catch (error) {
        // console.log(error);
      }
    }
    fetchData();
  }, [token, id]);

  return (
    <SimpleGrid
      spacing={4}
      px="2.5rem"
      templateColumns={"repeat(auto-fill, minmax(18%, 1fr))"}
    >
      <TotalDirectorate report={report.total_directorates} />
      <TotalDepartment report={report.total_departments} />

      <PendingReports report={report.pending_reports} />
      <QueriedReports report={report.queried_reports} />
      <ApprovedReports report={report.approved_reports} />
    </SimpleGrid>
  );
}
